const cashbackPaquetes = {
  LIBRETON_PREMIUM_WORLD: "$360.000",
  LIBRETON_PREMIUM: "$240.000",
  LIBRETON_FULL: "$120.000",
  LIBRETON_PLUS_GOLD: "$120.000",
  LIBRETON_EXPRESS: "$60.000",
  LIBRETON_PREMIUM_WORLD_CUOTA: "$120.000",
  LIBRETON_PREMIUM_CUOTA: "$80.000",
  LIBRETON_FULL_CUOTA: "$40.000",
  LIBRETON_PLUS_GOLD_CUOTA: "$40.000",
  LIBRETON_EXPRESS_CUOTA: "$20.000"
};

const AdwardsConfig = {
  libreton_express: {
    creditCard: {
      id: "1",
      srcAward: "",
      titleAward: "$10.000 a favor en tu tarjeta",
      detailsAward:
        "De crédito con tu cuenta Full para usar como y donde quieras"
    },
    LatamPass: {
      id: "2",
      srcAward: "",
      titleAward: "43.500 millas LATAM Pass",
      detailsAward: "Con tus paquetes Platinum o Black"
    },
    bonusPack: {
      id: "3",
      srcAward: "",
      titleAward: "Paquete 100% bonificado",
      detailsAward: "Bonificamos al 100% el mantenimiento de tu paquete"
    },
    loansExclusive: {
      id: "4",
      srcAward: "",
      titleAward: "Préstamos con tasa exclusiva",
      detailsAward: "En tu cuenta Clásica para préstamo personal e hipotecario"
    }
  },
  libreton_full: {
    creditCard: {
      id: "1",
      srcAward: "",
      titleAward: "$10.000 a favor en tu tarjeta",
      detailsAward:
        "De crédito con tu cuenta Full para usar como y donde quieras"
    },
    LatamPass: {
      id: "2",
      srcAward: "",
      titleAward: "43.500 millas LATAM Pass",
      detailsAward: "Con tus paquetes Platinum o Black"
    },
    bonusPack: {
      id: "3",
      srcAward: "",
      titleAward: "Paquete 100% bonificado",
      detailsAward: "Bonificamos al 100% el mantenimiento de tu paquete"
    },
    loansExclusive: {
      id: "4",
      srcAward: "",
      titleAward: "Préstamos con tasa exclusiva",
      detailsAward: "En tu cuenta Clásica para préstamo personal e hipotecario"
    }
  },
  libreton_plus_gold: {
    creditCard: {
      id: "1",
      srcAward: "",
      titleAward: "$10.000 a favor en tu tarjeta",
      detailsAward:
        "De crédito con tu cuenta Full para usar como y donde quieras"
    },
    libreton_premium: {
      id: "2",
      srcAward: "",
      titleAward: "43.500 millas LATAM Pass",
      detailsAward: "Con tus paquetes Platinum o Black"
    },
    bonusPack: {
      id: "3",
      srcAward: "",
      titleAward: "Paquete 100% bonificado",
      detailsAward: "Bonificamos al 100% el mantenimiento de tu paquete"
    },
    loansExclusive: {
      id: "4",
      srcAward: "",
      titleAward: "Préstamos con tasa exclusiva",
      detailsAward: "En tu cuenta Clásica para préstamo personal e hipotecario"
    }
  },
  libreton_premium_world: {
    creditCard: {
      id: "1",
      srcAward: "",
      titleAward: "$10.000 a favor en tu tarjeta",
      detailsAward:
        "De crédito con tu cuenta Full para usar como y donde quieras"
    },
    LatamPass: {
      id: "2",
      srcAward: "",
      titleAward: "43.500 millas LATAM Pass",
      detailsAward: "Con tus paquetes Platinum o Black"
    },
    bonusPack: {
      id: "3",
      srcAward: "",
      titleAward: "Paquete 100% bonificado",
      detailsAward: "Bonificamos al 100% el mantenimiento de tu paquete"
    },
    loansExclusive: {
      id: "4",
      srcAward: "",
      titleAward: "Préstamos con tasa exclusiva",
      detailsAward: "En tu cuenta Clásica para préstamo personal e hipotecario"
    }
  },
  default: {
    creditCard: {
      id: "4",
      srcAward: "",
      titleAward: "$10.000 de crédito a tu favor",
      detailsAward:
        "En tu <strong>tarjeta de crédito Visa</strong> con tu cuenta <strong>Full</strong>.",
      url: "wallet-money.svg"
    },
    LatamPass: {
      id: "3",
      srcAward: "",
      titleAward: "43.500 millas LATAM Pass",
      detailsAward:
        "Para viajar a EEUU o el Caribe con tu paquete <strong>Platinum</strong> y <strong>Black</strong>.",
      url: "plane.svg"
    },
    bonusPack: {
      id: "1",
      srcAward: "",
      titleAward: "Paquete 100% bonificado",
      detailsAward: "Bonificamos al 100% el mantenimiento de tu paquete",
      url: "account-dollar.svg"
    },
    loansExclusive: {
      id: "2",
      srcAward: "",
      titleAward: "Préstamos con tasa exclusiva",
      detailsAward: "En tu cuenta Clásica para préstamo personal e hipotecario",
      url: "loan-dollar.svg"
    }
  }
};

module.exports = {
  cashbackPaquetes,
  default: AdwardsConfig
};
